module.exports = new __parcel__URL__("shop_machines_valentines_picnic.453a65ec.png").toString();